import React, {useContext, useEffect, useState} from 'react';
import {Context} from "../index";
import "./csss/FileInfo.css";
import {observer} from "mobx-react-lite";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {autoGetPer, getSheet} from "../utils/utils";
import Means from "../components/Means";
import ChartsBlock from "../components/ChartsBlock/ChartsBlock";
import Table from "../components/Table";
import {count, countYearMeans, getColorClass} from "../utils/utils";
import {roundToSigns} from "../utils/utils";
import FileService from "../service/FileService";

function FileInfo() {
    const {fileStore} = useContext(Context)
    const [searchParams] = useSearchParams();
    const [index, setIndex] = useState(Number(searchParams.get("idx") || -1));
    const {id} = useParams()
    const navigate = useNavigate();

    const [fileSheet, setFileSheet] = useState(null);
    const [loadingSheet, setLoadingSheet] = useState(false);
    const [info, setInfo] = useState(null);
    const [allInfo, setAllInfo] = useState(null);
    const [yearInfo, setYearInfo] = useState(null);
    const [cls, setCls] = useState(-1);

    const idNum = Number(id);
    const isValidId = !isNaN(idNum) && idNum > 0 && Number.isInteger(idNum);
    const fileIndex = idNum - 1;
    const file = isValidId ? fileStore.files[fileIndex] : undefined;

    useEffect(() => {
        // После инициализации: если id невалидный или файла нет — редирект
        if (fileStore.isInit && (!isValidId || !file)) {
            navigate('/');
            return;
        }
    }, [fileStore.isInit, isValidId, file, navigate]);

// Основной эффект загрузки данных
    useEffect(() => {
        if (!fileStore.isInit || !isValidId) return;

        // Получаем актуальный файл на момент запуска эффекта
        const currentFileIndex = Number(id) - 1;
        const currentFile = fileStore.files[currentFileIndex];

        // Если файла нет — сразу выходим (редирект уже должен был сработать, но на всякий)
        if (!currentFile) {
            navigate('/');
            return;
        }

        let isCancelled = false;

        const load = async () => {
            setLoadingSheet(true);
            setFileSheet(null);

            try {
                if (isCancelled) return;

                const sheet = await getSheet(currentFile.serverName);
                if (!sheet) {
                    navigate('/')
                    console.log("dfdfdfdf")
                    return;
                }
                if (isCancelled) return;

                let indexCurr = index;
                if (index === -1) {
                    const res1 = await FileService.readFile("findBoundaryDates", {fileName: currentFile.serverName});
                    indexCurr = autoGetPer(res1.data)
                    if (indexCurr !== index) {
                        setIndex(autoGetPer(res1.data))
                    }
                }
                const res = await FileService.readFile("baseInfo", {fileName: currentFile.serverName, indexCurr});
                const baseInfo = res.data;
                if (isCancelled) return;

                if (Object.keys(baseInfo)[0].includes("I")) {
                    setAllInfo(baseInfo);
                    const year = countYearMeans(baseInfo);
                    setYearInfo({
                        yearInfo: year,
                        mean: roundToSigns(year.reduce((a, b) => a + b) / year.filter(a => a !== 0).length, 2, false),
                    });
                    const data = baseInfo[Object.keys(baseInfo)[0]];
                    setCls(Number(data.info["класс"].split(" ")[0]));
                    setFileSheet(sheet);
                    setInfo(data);
                    fileStore.setCurrentInfo(Object.values(data.info).join(', '));
                } else {
                    setCls(Number(baseInfo.info["класс"].split(" ")[0]));
                    setFileSheet(sheet);
                    setInfo(baseInfo);
                    fileStore.setCurrentInfo(Object.values(baseInfo.info).join(', '));
                }
            } catch (err) {
                if (!isCancelled) {
                    alert(`ОКАК: не удалось выгрузить информацию из файла - ${err?.response?.data?.message || err}`);
                    navigate('/');
                }
            } finally {
                if (!isCancelled) {
                    setLoadingSheet(false);
                }
            }
        };

        load();

        return () => {
            isCancelled = true;
        };
    }, [fileStore.isInit, id, navigate, fileStore]);

    if (!fileStore.isInit || loadingSheet || !fileSheet || index === -1) {
        return (
            <main style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 75px)' }}>
                <div className="spinner"></div>
            </main>
        );
    }

    return (
        <main>
            {fileStore.currentInfo && <div className="file-info for-phones">{fileStore.currentInfo}</div>}
            <div className="h2">Информация из выбранного файла:</div><br/>
            {fileStore.currentInfo?.split(",")[fileStore.currentInfo.split(",").length - 1].trim().toLowerCase() === "год" &&
                <div className="nav">
                    {cls >= 10 ?
                        ["I полугодие", "II полугодие", "Год"].map((item, i) => {
                            return <a key={i} href={`${id}?idx=${i+1}`} className={i+1 === index ? "active" : ""}>{item}</a>;
                        }) :
                        ["I четверть", "II четверть","III четверть", "IV четверть", "Год"].map((item, i) => {
                            return <a key={i} href={`${id}?idx=${i+1}`} className={i+1 === index ? "active" : ""}>{item}</a>;
                        }
                    )}
                </div>
            }
            {!allInfo ?
                <div className="all-info">
                    <div className="left">
                        <Means means={info.means} minEsts={info.minEsts} index={index}/>
                    </div>
                    <div className="right">
                        <div className="otherInfo">
                            Среднее всех оценок — <span className={info.allMean.colorClass}>{info.allMean.allMean}</span><br/>
                            Среднее итоговых — <span className={info.meanOfMeans.colorClass}>{info.meanOfMeans.mean}</span><br/><br/>
                            <span className="five">{info.counts[4]} пятёрок</span>; <span className="four">{info.counts[3]} четвёрок</span>; <span className="three">{info.counts[2]} троек</span>; <span className="two">{info.counts[1]} двоек</span>; <span className="one">{info.counts[0]} единиц</span><br/>
                            {info.counts[5] > 0 && <><span style={{color: "var(--gray-color)"}}>{`Не хватает оценок у ${info.counts[5]} предметов`}</span><br/></>}
                        </div>
                        <ChartsBlock allMarks={info.currMarks}/>
                    </div>
                </div>
                :
                <div className="all-info">
                    <div className="left">
                        <Table allInfo={allInfo}></Table>
                    </div>
                    <div className="right">
                        <div className="otherInfo">
                            Среднее всех оценок — <span className={allInfo["Год"].allMean.colorClass}>{allInfo["Год"].allMean.allMean}</span><br/>
                            Среднее итоговых — <span className={getColorClass(roundToSigns(Number(yearInfo.mean)))}>{yearInfo.mean}</span><br/><br/>
                            <span className="five">{count(yearInfo.yearInfo, 5)} пятёрок</span>; <span className="four">{count(yearInfo.yearInfo, 4)} четвёрок</span>; <span className="three">{count(yearInfo.yearInfo, 3)} троек</span>; <span className="two">{count(yearInfo.yearInfo, 2)} двоек</span>; <span className="one">{count(yearInfo.yearInfo, 1)} единиц</span><br/>
                        </div>
                    </div>
                </div>
            }
        </main>
    );
}

export default observer(FileInfo)
